<template>
  <div>
    <section class="hero hero-lp hero-christmas">
      <div class="hero-body">
        <div class="container">
          <div class="columns pt-5 pb-5 is-vcentered is-variable is-1" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <div class="column is-7-tablet is-7-desktop is-6-widescreen has-text-centered-mobile titlearea">
              <h1 class="title has-background-secondary is-inline-block is-size-4 is-size-3-tablet is-size-2-desktop has-text-weight-bold has-text-white pr-1 pl-1 mb-5">
                ADAC Hotelgutschein
              </h1>
              <h2 class="title christmas-title is-size-2 is-size-1-desktop has-text-weight-bold  is-size-2-tablet ">
                <p>Verschenken Sie</p>
                <p style="line-height: 0.75">kostbare Zeit zu Zweit</p>
              </h2>
              <!-- <p class="has-text-white-ter has-text-weight-bold is-size-5">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</p> -->
            </div>
            <div class="column has-text-centered">
              <img
                importance="high"
                src="https://assets.urlaubsgutschein.kaufen/i/resize?width=780&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png"
                srcset="
                  https://assets.urlaubsgutschein.kaufen/i/resize?width=402&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 402w,
                  https://assets.urlaubsgutschein.kaufen/i/resize?width=700&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 700w,
                  https://assets.urlaubsgutschein.kaufen/i/resize?width=278&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 278w,
                  https://assets.urlaubsgutschein.kaufen/i/resize?width=476&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 476w
                "
                sizes="(max-width: 480px) 432px,
                (max-width: 768px) 720px,
                (max-width: 1024px) 382px,
                (max-width: 1216px) 556px,
                (max-width: 1408px) 652px,
            666px
                "
                alt="Weihnachtsspecials"
                width="718"
                height="353"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile advantages-lp">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>

    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <h2 class="title">Unsere ADAC Hotelgutschein Weihnachtsspecials</h2>
            <!-- <h3 class="subtitle has-text-weight-bold">tba</h3> -->
            <div class="content">
              <p>
                Endlich Zeit zu Zweit verbringen und eine echte Auszeit vom Alltag genießen – gibt es etwas Kostbareres, haben Sie und Ihre Liebsten das nicht mehr als verdient? Verschenken Sie dieses Jahr kostbare Zeit zu Zweit! Zum Beispiel in einem exklusiven Mountain Resort, einem
                Wellness-Hotel, einem Luxus Chalet oder einem romantischen Hideaway. Das perfekte Geschenk für Weihnachten. Einfach ausdrucken, Freude schenken, flexibel reisen und dabei von unseren Rabatten profitieren.
              </p>
              <p class="has-text-weight-bold">3 Jahre gültig und übertragbar.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-offers">
      <div class="container">
        <div v-if="offers.length == 0" v-observe-visibility="contentVisibilityChanged">
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <div class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold">
                <b-icon icon="sad-cry" size="is-large"></b-icon>
                <br />Leider sind keine Angebote vorhanden!
              </div>
            </div>
          </div>

          <OfferBlock :title="$t('general.further-offers')" :offers="furtherOffers" v-if="isContentVisible" />

          <h3 class="title is-size-3 has-text-centered is-size-4-mobile">{{ $t('general.themes') }}</h3>
          <div class="columns is-centered">
            <div class="column is-10-desktop is-8-widescreen">
              <div class="buttons is-justify-content-center">
                <b-button
                  tag="router-link"
                  v-for="item in menu.themes"
                  :key="item.key"
                  :to="{
                    name: 'search-by-theme',
                    params: {
                      id: item.key,
                      name: $options.filters.removeSpecialChars(item.value),
                    },
                  }"
                  type="is-dark"
                >
                  {{ item.value }}
                </b-button>
              </div>
            </div>
          </div>

          <p class="has-text-centered has-text-weight-bold mt-5">Viele weitere Urlaubsgutscheine warten hier auf Sie!</p>
          <div class="has-text-centered mt-3">
            <b-button tag="router-link" to="/" type="is-dark">
              Zu allen Angeboten
            </b-button>
          </div>
        </div>

        <div v-if="offers.length > 0">
          <h2 class="title is-size-4 has-text-centered">Angebote enden in</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <!-- bzw für normale suche haspromotion | Custom:christmas -->

          <div class="columns is-multiline is-variable is-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--christmas" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/modules/hoteldisplay/_store'
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
import OfferApi from '@/api/offer-api'

const OfferBlock = () => import(/* webpackPrefetch: true , webpackChunkName: "offerblock" */ '@/components/OfferBlock')

export default {
  name: 'Christmas',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
    OfferBlock,
  },
  data() {
    return {
      offers: [],
      isContentVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      furtherOffers: '$_hotel/furtherOffers',
      menu: 'menu',
    }),
    campaignTimer: function() {
      let endDate = new Date('2021-12-25') - new Date()
      return endDate
    },
  },
  created() {
    const STORE_KEY = '$_hotel'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  async mounted() {
    const offers = await OfferApi.getOffersWithCustomPromotion('xmas21')
    this.offers = offers.sort((a, b) => b.rating - a.rating)

    this.$store.dispatch('$_hotel/getFurtherOffers')
  },
  methods: {
    contentVisibilityChanged(isVisible) {
      if (isVisible) {
        this.isContentVisible = true
      }
    },
  },
  metaInfo() {
    return {
      title: 'Urlaubsgutscheine zu Weihnachten schenken!',
      meta: [{name: 'description', content: 'Verschenken Sie dieses Jahr kostbare Zeit zu Zweit! Sichern Sie sich einen ADAC Hotelgutschein - das perfekte Geschenk für Weihnachten.'}],
    }
  },
}
</script>

<style lang="scss">
.hero-christmas {
  background-color: #fdda7b;
  background-image: url('https://template.we-are.travel/i/crop?width=697&height=650&gravity=south&interlace=true&quality=70&type=auto&file=whitelabel/adac/campaigns/weihnachten-bg.jpg');
  background-size: cover;

  @media screen and (min-width: 768px) {
    background-image: url('https://template.we-are.travel/i/crop?width=1216&height=390&gravity=south&interlace=true&quality=70&type=auto&file=whitelabel/adac/campaigns/weihnachten-bg.jpg');
  }
  @media screen and (min-width: 1216px) {
    background-image: url('https://template.we-are.travel/i/crop?width=1408&height=470&gravity=south&interlace=true&quality=70&type=auto&file=whitelabel/adac/campaigns/weihnachten-bg.jpg');
  }
  @media screen and (min-width: 1408px) {
    background-image: url('https://template.we-are.travel/i/crop?width=2560&height=500&gravity=south&interlace=true&quality=80&type=auto&file=whitelabel/adac/campaigns/weihnachten-bg.jpg');
  }
}

@media screen and (min-width: 1418px) {
  .christmas-title {
    font-size: 4rem !important;
  }
}
</style>
